import { I18n } from '@calendly/i18n'
import { DollarSign } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

import { getAmountWithSymbol } from 'components/event_type_edit'
import { useEventType } from 'features/event_type_provider'

const getSummary = ({ eventType, isLocked }) => {
  const { payment_method: paymentMethod } = eventType

  if (!paymentMethod || !paymentMethod.enabled) {
    return isLocked
      ? I18n.t('publisher.managed_event_types.payment.no_payment')
      : I18n.t('publisher.event_type_editor.sections.more_options.payment.helper_text')
  }

  const amount = Number(paymentMethod.amount_cents || 0) / 100

  return I18n.t('publisher.event_type_editor.sections.payment.subheader.configured', {
    amount: getAmountWithSymbol({ currency: paymentMethod.currency, amount }),
    provider: I18n.t(`publisher.integrations.names.${paymentMethod.provider}`)
  })
}

export const Summary = ({ isLocked, showIcon = true }) => {
  const eventType = useEventType()

  return (
    <BodyText color={colorTextSecondary} size="medium">
      {showIcon ? (
        <span data-testid="payment-summary-icon">
          <DollarSign size="standard" color={colorIconSecondary} spacingRight="8" />
        </span>
      ) : null}
      {getSummary({ eventType, isLocked })}
    </BodyText>
  )
}
